import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';

import EmailsAutomaticosServices from '../../services/emailsAutomaticos';
import './styles.css';

// Historico dos e-mails que saem quando o contrato fica com designer e status Ativo
const TIPOS = {
  designer: 'Designer e atendente',
  representante: 'Representante',
  financeiro: 'Financeiro'
};

const SITUACOES = {
  enviado: { rotulo: 'Enviado', classe: 'ea-situacao--enviado' },
  falhou: { rotulo: 'Falhou', classe: 'ea-situacao--falhou' },
  sem_destinatario: { rotulo: 'Sem destinatário', classe: 'ea-situacao--sem' }
};

const ATENDENTES = { priscila: 'Priscila', luana: 'Luana' };

function mensagemDoErro (erro, padrao) {
  return (erro && erro.response && erro.response.data && erro.response.data.error) || padrao;
}

class EmailsAutomaticos extends React.Component {

  state = {
    carregando: true,
    busca: '',
    tipo: '',
    status: '',
    pagina: 1,
    porPagina: 50,
    total: 0,
    resumo: {},
    itens: [],
    selecionado: null,
    confirmandoReenvio: false,
    reenviando: false
  }

  componentDidMount () {
    if (this.podeVer()) this.carregar(1);
  }

  // Administrador e orcamentista (o login "cad" do Wesley), as mesmas rotas
  // liberadas no servidor (routes.js, QUEM_VE_OS_EMAILS).
  podeVer () {
    return Boolean(this.props.usuario) && ['administrador', 'orc'].indexOf(this.props.usuario.tipo) > -1;
  }

  carregar (pagina) {
    const { busca, tipo, status } = this.state;
    this.setState({ carregando: true });
    new EmailsAutomaticosServices().listar({ busca, tipo, status, pagina }).then((resposta) => {
      this.setState({
        carregando: false,
        pagina: resposta.pagina,
        porPagina: resposta.porPagina,
        total: resposta.total,
        resumo: resposta.resumo || {},
        itens: resposta.itens || []
      });
    }).catch((erro) => {
      this.setState({ carregando: false });
      toast.error(mensagemDoErro(erro, 'Não foi possível carregar os e-mails automáticos.'));
    });
  }

  filtrar (campo, valor) {
    this.setState({ [campo]: valor }, () => this.carregar(1));
  }

  pesquisar (evento) {
    evento.preventDefault();
    this.carregar(1);
  }

  abrir (item) {
    this.setState({ selecionado: item, confirmandoReenvio: false });
  }

  fechar () {
    if (this.state.reenviando) return;
    this.setState({ selecionado: null, confirmandoReenvio: false });
  }

  reenviar () {
    const item = this.state.selecionado;
    this.setState({ reenviando: true });
    new EmailsAutomaticosServices().reenviar(item.id).then((resposta) => {
      if (resposta.enviado) {
        toast.success(`E-mail reenviado para ${resposta.para.join(', ')}.`);
      } else if (!resposta.para || resposta.para.length === 0) {
        toast.warn('Continua sem destinatário. Confira o e-mail no cadastro e tente de novo.');
      } else {
        toast.error('O e-mail não saiu de novo. O erro ficou registrado no histórico.');
      }
      this.setState({ reenviando: false, selecionado: null, confirmandoReenvio: false });
      this.carregar(1);
    }).catch((erro) => {
      this.setState({ reenviando: false });
      toast.error(mensagemDoErro(erro, 'Não foi possível reenviar o e-mail.'));
    });
  }

  _renderResumo () {
    const { resumo, status } = this.state;
    return (
      <div className="ea-resumo" role="group" aria-label="Filtrar pela situação">
        {Object.keys(SITUACOES).map((chave) => (
          <button
            key={chave}
            type="button"
            className={`ea-resumo-item ${SITUACOES[chave].classe}${status === chave ? ' ea-resumo-item--ativo' : ''}`}
            aria-pressed={status === chave}
            onClick={() => this.filtrar('status', status === chave ? '' : chave)}
          >
            <span className="ea-resumo-numero">{resumo[chave] || 0}</span>
            <span className="ea-resumo-rotulo">{SITUACOES[chave].rotulo}</span>
          </button>
        ))}
      </div>
    );
  }

  _renderFiltros () {
    return (
      <form className="ea-filtros" onSubmit={this.pesquisar.bind(this)}>
        <div className="input-group ea-busca">
          <input
            id="ea-busca"
            type="text"
            className="form-control"
            placeholder="Contrato, e-mail ou designer"
            value={this.state.busca}
            onChange={(e) => this.setState({ busca: e.target.value })}
          />
          <div className="input-group-btn">
            <button type="submit" className="btn btn-primary btn-flat"><i className="fa fa-search"></i> Buscar</button>
          </div>
        </div>
        <select id="ea-tipo" className="form-control ea-select" value={this.state.tipo} onChange={(e) => this.filtrar('tipo', e.target.value)}>
          <option value="">Todos os e-mails</option>
          {Object.keys(TIPOS).map((chave) => <option key={chave} value={chave}>{TIPOS[chave]}</option>)}
        </select>
        <select id="ea-status" className="form-control ea-select" value={this.state.status} onChange={(e) => this.filtrar('status', e.target.value)}>
          <option value="">Todas as situações</option>
          {Object.keys(SITUACOES).map((chave) => <option key={chave} value={chave}>{SITUACOES[chave].rotulo}</option>)}
        </select>
      </form>
    );
  }

  _renderSituacao (item) {
    const situacao = SITUACOES[item.status] || { rotulo: item.status, classe: '' };
    return (
      <span className="ea-situacao-celula">
        <span className={`ea-situacao ${situacao.classe}`}>{situacao.rotulo}</span>
        {item.redirecionadoPara ? <span className="ea-teste" title={`Modo teste: foi para ${item.redirecionadoPara}`}>teste</span> : null}
      </span>
    );
  }

  _renderTabela () {
    const { itens, carregando } = this.state;
    if (carregando) {
      return <div className="ea-vazio"><i className="fa fa-spinner fa-spin"></i> Carregando os e-mails…</div>;
    }
    if (itens.length === 0) {
      return (
        <div className="ea-vazio">
          Nenhum e-mail encontrado. Eles aparecem aqui quando um contrato fica com designer e status Ativo.
        </div>
      );
    }
    return (
      <div className="table-responsive">
        <table className="table table-hover ea-tabela">
          <thead>
            <tr>
              <th>Data</th>
              <th>Contrato</th>
              <th>E-mail</th>
              <th>Para</th>
              <th>Atendente</th>
              <th>Situação</th>
              <th><span className="sr-only">Ações</span></th>
            </tr>
          </thead>
          <tbody>
            {itens.map((item) => (
              <tr key={item.id}>
                <td className="ea-data">{moment(item.enviadoEm).format('DD/MM/YYYY HH:mm')}</td>
                <td><Link to={`/contratos/pesquisar?contrato=${item.numero}`} title="Abrir o contrato">{item.numero}</Link></td>
                <td>{TIPOS[item.tipo] || item.tipo}</td>
                <td className="ea-para" title={item.para}>{item.para || <span className="text-muted">ninguém</span>}</td>
                <td>{item.atendente ? <span className={`ea-atendente ea-atendente--${item.atendente}`}>{ATENDENTES[item.atendente] || item.atendente}</span> : <span className="text-muted">—</span>}</td>
                <td>{this._renderSituacao(item)}</td>
                <td className="ea-acoes">
                  <button type="button" className="btn btn-default btn-xs" onClick={() => this.abrir(item)}>
                    <i className="fa fa-eye"></i> Ver
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  _renderPaginacao () {
    const { pagina, porPagina, total, carregando } = this.state;
    const paginas = Math.max(1, Math.ceil(total / porPagina));
    if (carregando || total <= porPagina) return null;
    return (
      <div className="ea-paginacao">
        <button type="button" className="btn btn-default btn-sm" disabled={pagina <= 1} onClick={() => this.carregar(pagina - 1)}>
          <i className="fa fa-chevron-left"></i> Anteriores
        </button>
        <span>Página {pagina} de {paginas} · {total} e-mails</span>
        <button type="button" className="btn btn-default btn-sm" disabled={pagina >= paginas} onClick={() => this.carregar(pagina + 1)}>
          Próximos <i className="fa fa-chevron-right"></i>
        </button>
      </div>
    );
  }

  _renderDetalhe () {
    const item = this.state.selecionado;
    if (!item) return null;
    const { confirmandoReenvio, reenviando } = this.state;
    return (
      <Modal show onHide={this.fechar.bind(this)} dialogClassName="ea-modal">
        <Modal.Header closeButton>
          <Modal.Title>Contrato {item.numero} · {TIPOS[item.tipo] || item.tipo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <dl className="ea-detalhe">
            <dt>Data</dt><dd>{moment(item.enviadoEm).format('DD/MM/YYYY [às] HH:mm')}</dd>
            <dt>Situação</dt><dd>{this._renderSituacao(item)}</dd>
            <dt>Para</dt><dd>{item.para || 'ninguém'}</dd>
            {item.redirecionadoPara ? [<dt key="t">Foi para</dt>, <dd key="d">{item.redirecionadoPara} (modo teste)</dd>] : null}
            {item.atendente ? [<dt key="t">Atendente</dt>, <dd key="d">{ATENDENTES[item.atendente] || item.atendente}</dd>] : null}
            {item.designer ? [<dt key="t">Designer</dt>, <dd key="d">{item.designer}</dd>] : null}
            <dt>Assunto</dt><dd><strong>{item.assunto}</strong></dd>
          </dl>
          {item.status === 'sem_destinatario' ? (
            <div className="ea-alerta">
              O e-mail não saiu porque não havia destinatário. No e-mail do representante, isso significa que o cadastro dele no Mapa está sem e-mail. Corrija o cadastro e reenvie.
            </div>
          ) : null}
          {item.status === 'falhou' ? (
            <div className="ea-alerta ea-alerta--erro">
              O servidor de e-mail recusou o envio{item.erro ? `: ${item.erro}` : '.'}
            </div>
          ) : null}
          <div className="ea-corpo" aria-label="Texto do e-mail">{item.corpo}</div>
        </Modal.Body>
        <Modal.Footer>
          {confirmandoReenvio ? (
            <div className="ea-confirmar">
              <span>Vai sair de novo com os dados e destinatários atuais do contrato.</span>
              <button type="button" className="btn btn-default" disabled={reenviando} onClick={() => this.setState({ confirmandoReenvio: false })}>Cancelar</button>
              <button type="button" className="btn btn-primary" disabled={reenviando} onClick={this.reenviar.bind(this)}>
                {reenviando ? <span><i className="fa fa-spinner fa-spin"></i> Reenviando</span> : 'Confirmar reenvio'}
              </button>
            </div>
          ) : (
            <div className="ea-confirmar">
              <button type="button" className="btn btn-default" onClick={this.fechar.bind(this)}>Fechar</button>
              <button type="button" className="btn btn-primary" onClick={() => this.setState({ confirmandoReenvio: true })}>
                <i className="fa fa-paper-plane"></i> Reenviar
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    );
  }

  render () {
    if (!this.podeVer()) return <Redirect to="/unauthorized" />;
    return (
      <div className="ea-pagina">
        <div className="box">
          <div className="box-body">
            <div className="ea-cabecalho">
              <div>
                <h3 className="ea-titulo">E-mails automáticos</h3>
                <p className="ea-subtitulo">
                  Saem quando o contrato fica com designer e status Ativo: designer e atendente, representante e financeiro.
                </p>
              </div>
              {this._renderResumo()}
            </div>
            {this._renderFiltros()}
            {this._renderTabela()}
            {this._renderPaginacao()}
          </div>
        </div>
        {this._renderDetalhe()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado
  };
};

export default connect(mapStateToProps)(EmailsAutomaticos);



// WEBPACK FOOTER //
// ./src/views/EmailsAutomaticos/index.js